var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "32px",
    viewBox: "0 0 35 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basestation-Selected",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    transform: "translate(-271.000000, -10.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-from-bra-copy",
    transform: "translate(271.000000, 10.562500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125,28.984375 C13.125,29.8935539 12.3935549,30.625 11.484375,30.625 L6.5625,30.625 C2.93808565,30.625 0,27.6869133 0,24.0625 L0,6.5625 C0,2.9380846 2.93808565,0 6.5625,0 L11.484375,0 C12.3935549,0 13.125,0.73417902 13.125,1.640625 C13.125,2.54638672 12.3935549,3.28125 11.484375,3.28125 L6.5625,3.28125 C4.75781187,3.28125 3.28124896,4.75781292 3.28124896,6.5625 L3.28124896,24.0625 C3.28124896,25.8671871 4.75781187,27.34375 6.5625,27.34375 L11.484375,27.34375 C12.3935549,27.34375 13.125,28.0751961 13.125,28.984375 Z M34.5556641,14.1914067 C35.1503915,14.8203127 35.1503915,15.8046883 34.4305673,16.4361906 L25.7420903,25.7330656 C25.419434,26.076982 24.983643,26.25 24.547852,26.25 C24.2060551,26.25 23.8027352,26.0996085 23.4206754,25.8036134 C22.7605969,25.1835933 22.7285367,24.1456252 23.3501965,23.4855467 L29.4970703,16.953125 L12.516602,16.953125 C11.6723633,16.953125 10.9375,16.2148446 10.9375,15.3125 C10.9375,14.4101565 11.6689451,13.671875 12.516602,13.671875 L29.5585933,13.671875 L23.4786415,7.14211941 C22.8573239,6.48176759 22.8890419,5.44352621 23.5491204,4.82405275 C24.2074215,4.20273513 25.2455273,4.23226476 25.8671871,4.89453167 L34.5556641,14.1914067 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/signOut.e7e58ab429c8991d9fda21c32e67a48b.svg";
export { ForwardRef as ReactComponent };